import { render, staticRenderFns } from "./PrintingGroupList.vue?vue&type=template&id=c2411710&"
import script from "./PrintingGroupList.vue?vue&type=script&lang=js&"
export * from "./PrintingGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports